import buildThreadContentItems from '@/lib/threads/buildThreadContentItems.js';

const upsertThreadContentItem = (threadContent = [], threadContentItem = null) => {
  const normalizedThreadId = String(threadContentItem?.threadId || '').trim();

  if (!normalizedThreadId) {
    return buildThreadContentItems(threadContent);
  }

  const existingItems = buildThreadContentItems(threadContent);
  const nextItems = existingItems.map((item) => {
    return String(item?.threadId || '').trim() === normalizedThreadId ? { ...threadContentItem, threadId: normalizedThreadId } : item;
  });

  if (!nextItems.some((item) => String(item?.threadId || '').trim() === normalizedThreadId)) {
    nextItems.push({
      ...threadContentItem,
      threadId: normalizedThreadId
    });
  }

  return buildThreadContentItems(nextItems);
};

export default upsertThreadContentItem;
